export const INVITE_SYSTEM_ENABLED = false;
